import React from 'react';
import { AvTag, AvTooltip } from '@fabric-ui/components';
import { AlertsFull, AssetsFull, FindingsFull, IdentitiesFull, IncidentsFull, Risk360Full, ThreatsFull } from '@fabric-ui/icons/app-icons';
import { ellipsis, flex } from '@fabric-ui/theme';
import { Box, Button, capitalize } from '@mui/material';
import { APP_PATHS, AppPathKey } from '../types';
import { appsOptions } from './newNavigation/appbar.constants';

const iconComponents = {
  VULNERABILITIES: FindingsFull,
  DETECTIONS: AlertsFull,
  INCIDENTS: IncidentsFull,
  RISK360: Risk360Full,
  ASSETS: AssetsFull,
  THREATS: ThreatsFull,
  IDENTITIES: IdentitiesFull,
};

interface Props {
  apps: AppPathKey[];
}

export const AppIcon = ({ app }) => {
  const appConfig = appsOptions.find(({ enumValue }) => enumValue === app)!;
  const IconComponent = iconComponents[app];
  return (
    <AvTooltip
      title={capitalize(appConfig.name)}
      key={appConfig.name}
      muiProps={{ placement: 'top' }}
      popperProps={{ modifiers: [{ name: 'offset', options: { offset: [2, -8] } }] }}>
      <Button>
        <Box sx={{ borderRadius: '8px', ...flex.center, svg: { width: 22, height: 22 } }}>
          <IconComponent />
        </Box>
      </Button>
    </AvTooltip>
  );
};

const AvAppTag: React.FC<Props> = ({ apps }) => (
  <Box sx={{ ...flex.itemsCenter, gap: 1, whiteSpace: 'nowrap' }}>
    {apps.map(app => {
      const appConfig = appsOptions.find(({ id }) => id === APP_PATHS[app])!;
      const IconComponent = iconComponents[app];
      return (
        <AvTag
          sx={{ pl: 0, py: 0 }}
          key={app}
          text={
            <Box
              sx={{
                ...flex.itemsCenter,
                gap: '6px',
                ...ellipsis,
                borderBottomLeftRadius: 7,
                borderTopLeftRadius: 7,
                svg: { width: 22, height: 22 },
              }}>
              <IconComponent />
              <span>{appConfig.name}</span>
            </Box>
          }
        />
      );
    })}
  </Box>
);

export default AvAppTag;
